module.exports = __webpack_public_path__ + "img/crotch_height.f80e0671.png";